import { InferType, number, object, string } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  pendingVisitId: string().required(),
  statusReasonCode: number().required(),
})

export type Request = InferType<typeof Schema>

export type SuccessfulResponse = {
  data: {
    pendingVisitId: string
    status: string
    rescheduleRequestedAt: string
    rescheduleRequestExpiresAt: string
  }
}

export const url = ({ pendingVisitId }: Request) => `/v1/visit/pending/${pendingVisitId}/request-reschedule`

export const getBody = ({ statusReasonCode }: Request) => ({
  status_reason_code: statusReasonCode,
})
